import React from 'react';
import { motion } from 'framer-motion';
import { FloatingParticles } from './Decorative';
import { useLanguage } from '../i18n/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="inicio" className="relative min-h-screen flex flex-col justify-end overflow-hidden pb-24 md:pb-32" data-id="element-411">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-412">
        <motion.img initial={{
        scale: 1.05
      }} animate={{
        scale: 1
      }} transition={{
        duration: 20,
        ease: 'linear',
        repeat: Infinity,
        repeatType: 'reverse'
      }} src="https://cdn.magicpatterns.com/uploads/bDF8VKn8pKKCH33vNVZewD/foto_portada_inicio_FOTO_1.png" alt="Camino entre flores hacia el árbol de la vida" className="w-full h-full object-cover object-center" data-id="element-413" />
        {/* Light overlay for text readability */}
        <div className="absolute inset-0" style={{
        background: 'rgba(15,35,25,0.25)'
      }} data-id="element-414"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-cream/95" data-id="element-415"></div>
      </div>

      {/* Brighter floating particles layer */}
      <FloatingParticles count={40} color="bg-gold-light shadow-[0_0_10px_rgba(229,200,140,1)]" data-id="element-416" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-5 sm:px-6 text-center w-full" data-id="element-417">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: 'easeOut',
        delay: 0.3
      }} className="flex flex-col items-center" data-id="element-418">
          {/* Name — large elegant serif */}
          <h2 className="text-cream drop-shadow-lg leading-tight" style={{
          fontFamily: 'Cormorant Garamond, serif',
          fontWeight: 400,
          fontSize: 'clamp(40px, 6vw, 78px)',
          letterSpacing: '0.04em'
        }} data-id="element-419">
            {t('hero.name')}
          </h2>

          {/* Gold ornament divider */}
          <div className="flex items-center gap-4 my-5" data-id="element-420">
            <div className="h-[1px] w-12 sm:w-20 bg-gold-light/70" data-id="element-421"></div>
            <span className="text-gold-light text-xs" data-id="element-422">✦</span>
            <div className="h-[1px] w-12 sm:w-20 bg-gold-light/70" data-id="element-423"></div>
          </div>

          {/* Role — uppercase tracking-widest */}
          <p className="uppercase" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 700,
          fontSize: 'clamp(16px, 1.7vw, 22px)',
          letterSpacing: '0.4em',
          paddingLeft: '0.4em',
          color: '#0f2318',
          textShadow: '0 0 14px rgba(255,255,255,0.95), 0 0 8px rgba(255,255,255,0.95), 0 1px 3px rgba(255,255,255,1)'
        }} data-id="element-424">
            {t('hero.role')}
          </p>
        </motion.div>
      </div>
    </section>;
}